import src from "IMAGE";
export default { src, width: 371, height: 303, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
